<form [formGroup]="fcItemFormGroup" id="{{baseId}}-modal-form" #modalForm="ngForm" (ngSubmit)="save()">
  <div class="emds">
    <div class="modal-default modal-flex">
      <div class="modal-header">
        <ng-container *ngIf="fcModalItemContext.mode==fcItemModalModeEnum.Modify">
          <span id="{{baseId}}-header-title" translate>Modify {{fcModalItemContext.findControlName}} - {{fcModalItemContext.selectedFindItemName}}</span>
        </ng-container>
        <ng-container *ngIf="fcModalItemContext.mode==fcItemModalModeEnum.New">
          <span id="{{baseId}}-header-title" translate>New {{fcModalItemContext.findControlName}}</span>
        </ng-container>
      </div>

      <div class="modal-body">
        <ap-alert></ap-alert>
        <div *ngIf="isLoading">
          <div class="text-center">
            <ap-spinner size="2"></ap-spinner>
          </div>
        </div>

        <div *ngIf="!isLoading">
          <fc-generic-list
            [form]="modalForm"
            [baseId]="baseId"
            [genericListFormGroup]="fcItemFormGroup.controls.genericList"
            [genericListItem]="genericListItem"
          ></fc-generic-list>
        </div>
      </div>

      <div class="modal-footer">
        <button type="submit" id="{{baseId}}-save-btn"
                class="btn btn-primary"
                [disabled]="!fcItemFormGroup?.dirty || isSaving"
                translate>
          <ap-spinner *ngIf="isSaving; else notSaving" size="1"></ap-spinner>
          <ng-template #notSaving>
            Save
          </ng-template>
        </button>
        <button type="button" id="{{baseId}}-cancel-btn"
                class="btn btn-secondary btn-flush-right"
                (click)="onCancel()" translate>
          Cancel
        </button>
      </div>
    </div>
  </div>
</form>
